import React, { useState, useEffect } from "react";
import I18n from "i18n-js";
import _ from "lodash";

import Selector from "./../Selector";

import Dropdown from "./Dropdown";

const MemberPlanSelector = ({
  team,
  members,
  showMyPlan,
  isMemberSelected = () => false,
  onMemberClick = null
}) => {

  const [selectedMember, setSelectedMember] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    let items = members.filter(m => !m?.logged_user);
    items = _.sortBy(items, ["first_name", "last_name"])
      .map(member => getDropdownItem(member));

    if (showMyPlan) {
      const loggedUser = members.find(m => m?.logged_user);
      items.unshift(getDropdownItem(loggedUser, true));
    }

    setItems(items);
  }, [members, isMemberSelected, onMemberClick]);

  const getDropdownItem = (member, isMyPlan = false) => {
    const url = getPlanUrl(member);
    const status = url ? member?.development_plan?.status : "no_plan";
    const tooltip = member?.email;
    
    const title = isMyPlan
      ? I18n.t("pdp.plan_selector.my_plan")
      : getUserName(member) || tooltip;
    
    const isDraft = member?.development_plan?.status === "draft";

    const isSelected = isMemberSelected(member);
    if (isSelected) {
      setSelectedMember(member);
    }
  
    return {
      title: title,
      tooltip: tooltip,
      url: !isMyPlan && isDraft ? null : url,
      clickable: Boolean(onMemberClick) || Boolean(url) && (isMyPlan || !isDraft),
      selected: isSelected,
      status: status,
      user_uuid: member?.uuid,
      uuid: member?.development_plan?.uuid,
      plan: member?.development_plan,
      onClick: onMemberClick
    };
  }

  const getUserName = (member) => {
    const lastName = member?.last_name ? member?.last_name?.substr(0, 1) + "." : "";
    return member?.first_name ? `${member?.first_name} ${lastName}` : "";
  }

  const getPlanUrl = (member) => {
    if (!member?.development_plan?.uuid) { return null; }
    return `/teams/${team.uuid}/pdp/${member?.development_plan?.uuid}?locale=${I18n.locale}`;
  }

  const title = !selectedMember
    ? I18n.t("pdp.plan_selector.select_plan")
    : selectedMember?.logged_user
      ? I18n.t("pdp.plan_selector.my_plan")
      : getUserName(selectedMember) || selectedMember?.email;

  return (
    <Selector
      className="member-plan-selector"
      title={title}
      items={items}
      DropdownComp={Dropdown}
    />
  );
}

export default MemberPlanSelector;
